<template>
  <div class="layout-root">
    <side-bar class="sidebar-container" />
    <div class="main-container">
      <nav-bar />
      <div id="sansanll-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { rpc } from '../../service/index';
import { M } from '../../service/grpc';
import { getToken } from '../../service/helper';
import { setTimeout, clearTimeout } from 'timers';
import sidebar from './sidebar/index.vue';
import navbar from './navbar/index.vue';

export default {
  components: {
    'side-bar': sidebar,
    'nav-bar': navbar
  },
  data() {
    return {
      token: getToken(),
      dueDate: '',
      second: 0,
      nIntervId: null,
      store: {},
      minapp: null
    };
  },
  async created() {
  },
  destroyed() {
  },
  methods: {
  }
};
</script>

<style lang="scss">
$sidebarWidth: 200px;

.main-banner {
  background-color: #fffae2;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

#sansanll-content {
  // height: 100vh;
  min-width: 960px;
}

.main-banner_left {
  display: flex;
  align-items: center;
  .info {
    margin-left: 10px;
  }
  .title {
    margin: 0;
    font-size: 14px;
  }
  .desc {
    margin-top: 2px;
    font-size: 12px;
    color: #666;
  }
}

.layout-root {
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow: hidden;
}
.sidebar-container {
  background-color: rgb(48, 65, 86);
  transition: width 0.28s;
  width: $sidebarWidth !important;
  height: 100vh;
  position: fixed !important;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  overflow: hidden;
  .el-menu {
    width: 100%;
  }
}
.main-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding-left: $sidebarWidth;
  box-sizing: border-box;
  transition: padding-left 0.28s;
}
.sidebar-container .el-submenu .el-menu-item {
  min-width: $sidebarWidth !important;
  padding: 0 46px !important;
}
</style>
